import { useEffect, useRef, useState } from 'react';
import { downloadProductExport } from '../../lib/productExport';

export default function ProductExportDialog({ review, canEdit, onClose }) {
  const dialogRef = useRef(null);
  const [error, setError] = useState('');
  const [downloaded, setDownloaded] = useState(false);
  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  const { file, errors, warnings } = review;
  const download = () => {
    if (!canEdit || errors.length) return;
    try { downloadProductExport(review); setDownloaded(true); setError(''); }
    catch (failure) { setError(failure.message || 'No se pudo descargar el archivo.'); }
  };
  return (
    <dialog ref={dialogRef} aria-labelledby="product-export-title" onCancel={(event) => { event.preventDefault(); onClose(); }} className="m-auto w-[calc(100%-1.5rem)] max-w-2xl max-h-[90dvh] overflow-y-auto rounded-2xl bg-white p-0 text-slate-900 shadow-xl backdrop:bg-black/50">
      <div className="border-b border-slate-200 p-4 sm:p-6">
        <h2 id="product-export-title" className="text-xl font-bold">Exportar productos</h2>
        <p className="mt-1 text-sm text-slate-600">Revisa esta copia del catálogo antes de descargar.</p>
      </div>
      <div className="space-y-4 p-4 sm:p-6">
        <dl className="grid gap-2 rounded-xl bg-sky-50 p-4 text-sm">
          <div className="flex justify-between gap-3"><dt>Productos seleccionados</dt><dd className="font-bold">{file.products.length}</dd></div>
          <div className="flex justify-between gap-3"><dt>Dependencias adicionales</dt><dd className="font-bold">{file.dependencies.products.length}</dd></div>
          <div className="flex justify-between gap-3"><dt>Selectores dinámicos</dt><dd className="font-bold">{file.dependencies.selectors.length}</dd></div>
        </dl>
        <p className="rounded-xl bg-slate-100 p-3 text-sm">No se incluyen existencias ni imágenes. El archivo incluye precios y costos. Esta descarga no cambia el catálogo.</p>
        <details open>
          <summary className="cursor-pointer font-semibold">Productos seleccionados</summary>
          <ul className="mt-2 max-h-40 list-disc overflow-auto pl-5 text-sm">{file.products.map((node) => <li key={node.ref}>{node.data.name}</li>)}</ul>
        </details>
        {file.dependencies.products.length > 0 && <details>
          <summary className="cursor-pointer font-semibold">Productos e insumos requeridos ({file.dependencies.products.length})</summary>
          <ul className="mt-2 max-h-48 list-disc overflow-auto pl-5 text-sm">{file.dependencies.products.map((node) => <li key={node.ref}>{node.data.name}</li>)}</ul>
        </details>}
        {file.dependencies.selectors.length > 0 && <details>
          <summary className="cursor-pointer font-semibold">Categorías incluidas</summary>
          <ul className="mt-2 list-disc pl-5 text-sm">{file.dependencies.selectors.map((selector) => <li key={selector.ref}>{selector.sourceCategory} · {selector.unit} · {selector.memberRefs.length} opciones</li>)}</ul>
        </details>}
        {warnings.length > 0 && <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-950">
          <h3 className="font-bold">Advertencias ({warnings.length})</h3>
          <ul className="mt-2 list-disc space-y-2 pl-5">{warnings.map((warning, i) => <li key={i}><b>{warning.product}:</b> {warning.message}</li>)}</ul>
        </div>}
        {errors.length > 0 && <div role="alert" className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-900">
          <h3 className="font-bold">Descarga bloqueada</h3>
          <p className="mt-1">Cancela y quita de la selección los productos afectados, o corrige sus dependencias antes de volver a exportar.</p>
          <ul className="mt-2 max-h-56 list-disc space-y-1 overflow-auto break-words pl-5">{errors.map((message, i) => <li key={i}>{message}</li>)}</ul>
        </div>}
        {!canEdit && <p role="alert">Ya no tienes permiso de edición de Productos.</p>}
        {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
        {downloaded && <p role="status" className="text-sm text-emerald-800">Archivo generado. Revisa las descargas del navegador.</p>}
      </div>
      <div className="sticky bottom-0 flex flex-wrap justify-end gap-2 border-t border-slate-200 bg-white p-4">
        <button type="button" onClick={onClose} className="rounded-lg border border-slate-300 px-4 py-2">{downloaded ? 'Cerrar' : 'Cancelar'}</button>
        <button type="button" onClick={download} disabled={!canEdit || errors.length > 0} className="rounded-lg bg-sky-700 px-4 py-2 font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50">Descargar JSON</button>
      </div>
    </dialog>
  );
}
